export default function (db) {
    db.Collection.prototype.transform = async function(transformer) {
        return await transformer.handle(this)
    }
}
